import { render, staticRenderFns } from "./ObjectField.vue?vue&type=template&id=5b2aeba6&lang=pug&"
import script from "./ObjectField.vue?vue&type=script&lang=js&"
export * from "./ObjectField.vue?vue&type=script&lang=js&"
import style0 from "./ObjectField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2aeba6')) {
      api.createRecord('5b2aeba6', component.options)
    } else {
      api.reload('5b2aeba6', component.options)
    }
    module.hot.accept("./ObjectField.vue?vue&type=template&id=5b2aeba6&lang=pug&", function () {
      api.rerender('5b2aeba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/ObjectField.vue"
export default component.exports